import { render, staticRenderFns } from "./SelectableRows.vue?vue&type=template&id=8d013b9c&"
import script from "./SelectableRows.vue?vue&type=script&lang=js&"
export * from "./SelectableRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports